import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { hideDialog } from '../../../redux/actions/dialogs';
import styles from './styles';

class ReduxDialog extends React.Component {
  handleDiscard = () => {
    this.props.hideDialog(this.props.name);
  };

  renderTitle() {
    const { title, subtitle, rightToolbar } = this.props;

    if (!title && !subtitle && !rightToolbar) {
      return null;
    }

    return (<DialogTitle style={this.props.titleStyle || styles.title}>
      <div style={styles.titleContainer}>
        <div style={styles.titleSubTitleContainer}>
          <div style={styles.title}>{title}</div>
          {subtitle ? <div style={_.assign({}, styles.subTitle, this.props.subTitleStyle)}>{subtitle}</div> : null}
        </div>
        {rightToolbar}
      </div>
    </DialogTitle>);
  }

  renderActions() {
    const { actions } = this.props;

    return (<DialogActions>
      {actions}
    </DialogActions>);
  }

  render() {
    const { open, fullScreen, fullWidth, maxWidth, contentStyle, dialogStyle } = this.props;
    return (
      <Dialog
        open={open === true}
        onClose={this.handleDiscard}
        fullScreen={fullScreen}
        fullWidth={fullWidth}
        maxWidth={maxWidth}
        style={dialogStyle}
      >
        {this.renderTitle()}

        <DialogContent style={contentStyle || styles.content}>
          {this.props.children}
        </DialogContent>

        {this.renderActions()}

      </Dialog>
    );
  }
}

ReduxDialog.propTypes = {
  name: PropTypes.string.isRequired,
  title: PropTypes.string,
  subTitle: PropTypes.string,
  fullWidth: PropTypes.bool,
  fullScreen: PropTypes.bool,
  maxWidth: PropTypes.string,
  modal: PropTypes.bool,
  actions: PropTypes.array.isRequired,
  children: PropTypes.any.isRequired,
  dialogStyle: PropTypes.object,
  titleStyle: PropTypes.object,
  subTitleStyle: PropTypes.object,
  bodyStyle: PropTypes.object,
  contentStyle: PropTypes.object,
  overlayStyle: PropTypes.object,
  rightToolbar: PropTypes.object,
};

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    hideDialog,
  }, dispatch);
}

function mapStateToProps(state, props) {
  return {
    open: state.getIn(['dialogs', props.name, 'visible']) || false,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ReduxDialog);



// WEBPACK FOOTER //
// ./src/components/Common/ReduxDialog/index.js